import { useNavigate } from 'react-router-dom';
import "./TopMenu.css";

export const TopMenu = ({ isAuthenticated, userType, searchKeyword, setSearchKeyword, handleLogout }) => {

  const navigate = useNavigate();
  const gotoMain = () => {
    navigate('/');
  };

  const handleSearch = () => {
    navigate(`/studio-tour?search=${encodeURIComponent(searchKeyword)}`);
  };

  const renderUserArea = () => {
    if (!isAuthenticated) {
      return (
        <div className="top-menu__user-area">
          <div className="top-menu__text-color-deep-green" onClick={() => window.open('https://litt.ly/atelier_tour', '_blank')} >
            아틀리에 투어 예약
          </div>
          <div className="top-menu__text-black" onClick={() => navigate('/login')} >로그인</div>
        </div>
      );
    }

    if (userType === 'user') {
      return (
        <div className="top-menu__user-area">
          <div className="top-menu__text-color-deep-green" onClick={() => window.open('https://litt.ly/atelier_tour', '_blank')} >
            아틀리에 투어 예약
          </div>
          <div className="top-menu__text-black" onClick={() => navigate('/customer-mypage')} >마이페이지</div>
          <div className="top-menu__text-black" onClick={handleLogout} >로그아웃</div>
        </div>
      );
    }

    return (
      <div className="top-menu__user-area">
        <div className="top-menu__text-color-deep-green" onClick={() => window.open('https://litt.ly/atelier_tour', '_blank')} >
          아틀리에 투어 예약
        </div>
        <div className="top-menu__text-black" onClick={() => navigate('/artist-studio')} >내 아틀리에</div>
        <div className="top-menu__text-black" onClick={() => navigate('/artist-mypage')} >마이페이지</div>
        <div className="top-menu__text-black" onClick={handleLogout} >로그아웃</div>
      </div>
    );
  };

  return (
    <div className="top-menu">
      <img className="top-menu__logo-image" src="/icons/yournest_horizontal_logo.svg" onClick={gotoMain}/>
      <div className="top-menu__search-area">
        <input className="top-menu__search-text" placeholder="오늘은 어디를 가볼까요?" value={searchKeyword} onChange={(e) => setSearchKeyword(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleSearch()}/>
        <img className="top-menu__search-icon" src="/icons/btn_search.svg" alt="search icon" onClick={handleSearch}/>
      </div>
      {renderUserArea()}
    </div>
  );
};